import "./styles.css";

const Loading = (props) => {
  return (
    <div className={`${props.fullScreen && "loader-fullscreen"}`}>
      <span className={`loader ${props.className}`}></span>
    </div>
  );
};

export default Loading;
